<template>
  <div class="wbs-footer">WBSPacs-Manager - {{version}}v</div>
</template>
<script>
import {version} from "../../../package.json"

export default {
  name: "appRodape",
  data() {
    return {
      version: version
    }
  },
}
</script>
<style lang="scss">
.wbs-footer {
  position: absolute;
  bottom: 0;
}
</style>
